import { render, staticRenderFns } from "./ProgramBanner.vue?vue&type=template&id=2a97997d&"
import script from "./ProgramBanner.vue?vue&type=script&lang=js&"
export * from "./ProgramBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports